import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ZefAvatarModule } from '@zerops/zef/avatar';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZefPipesModule } from '@zerops/zef/pipes';
import { ClientListItemComponent } from './client-list-item.component';
import { RoleBadgeComponent } from '../role-badge';

@NgModule({
  declarations: [ ClientListItemComponent ],
  imports: [
     ZefAvatarModule,
     ZefCopyToClipboardModule,
     MatIconModule,
     CommonModule,
     ZefPipesModule,
     RoleBadgeComponent
  ],
  exports: [ ClientListItemComponent ]
})
export class ClientListItemModule {

}
